import { render, staticRenderFns } from "./alarmServerManage.vue?vue&type=template&id=56af4d29&"
import script from "./alarmServerManage.vue?vue&type=script&lang=js&"
export * from "./alarmServerManage.vue?vue&type=script&lang=js&"
import style0 from "./alarmServerManage.vue?vue&type=style&index=0&id=56af4d29&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports